import React from 'react';
import { StickyTable, SvgIcon, ITableProps } from '@gik/ui';
import { competitors } from '../constants/competitors';
import i18n from '@gik/i18n';
import bemBlock from '@gik/core/utils/bemBlock';

interface ICompetitorsTableItem {
  id: string;
  name?: string;
  description: React.ReactNode;
  useStickyHeader?: boolean;
}

export interface ICompetitorsComparisonTableProps<T extends object> extends Omit<ITableProps<T>, 'data' | 'columns'> {}

const blockName = 'competitors-comparison-table';

export default function CompetitorsComparisonTable<T extends object>({
  className,
  hasStickyHeader: useStickyHeader = true,
}: ICompetitorsComparisonTableProps<T>): React.ReactElement {
  const bem = bemBlock(blockName);

  const allColumns = [
    {
      Header: (
        // <Image
        //   className={bem('gik-logo')}
        //   asBackground
        //   proportion={new Proportion(199, 58)}
        //   src={`${getAssetsUrl()}core/img/icons/giveinkind-logo.svg`}
        // />
        <div className={bem('gik-logo')}>Give InKind</div>
      ),
      accessor: 'description',
      sticky: 'left',
    },
    ...competitors
      .filter(item => item.id !== 'giveinkind')
      .map(competitor => {
        return {
          Header: competitor.name,
          accessor: competitor.id,
        };
      }),
  ];

  // create table data from the competitors collection
  const data: ICompetitorsTableItem[] = React.useMemo(() => {
    return Object.keys(competitors[0].features).map(featureKey => {
      const competitorFeatures = {};
      competitors.forEach(competitor => {
        const svgClassName =
          competitor.id === 'giveinkind' ? 'tw-text-success-500 gik-checkmark' : 'tw-text-neutral-600';
        competitorFeatures[competitor.id] = competitor.features[featureKey] ? (
          <SvgIcon name="CheckCircle" className={svgClassName} />
        ) : (
          ''
        );
      });

      const model = {
        id: featureKey,
        description: (
          <div className="gik-competitors-comparison-table__firstCol">
            <main>{i18n.t(`marketing-features.${featureKey}`)}</main>
            <aside>
              <SvgIcon name="CheckCircle" className="tw-text-success-500 gik-checkmark" />
            </aside>
          </div>
        ),
        ...competitorFeatures,
      };

      return model;
    });
  }, []);

  return (
    <StickyTable
      useStickyHeader={useStickyHeader}
      data={data}
      columns={allColumns}
      className={bem(null, null, className)}
      fullWidth
    />
  );
}
